export default "/body-background.19fa146aeaf30db5e3c527ea6ac4b454.png";